import { call, put, select, takeEvery } from 'redux-saga/effects';
import { newDealerActionCreators, NewDealerActionKeys } from '../';
import { IState } from '../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { DeleteNewDealerRequestCompleteEvent } from '../newDealerActionTypes';
import * as api from '../newDealerApi';
import { INewDealerRequestCompleteEvent } from '../newDealerInterfaces';
import { getNewDealerRequestCompleteEvent } from '../newDealerSelectors';

function* deleteNewDealerRequestCompleteEvent(action: DeleteNewDealerRequestCompleteEvent) {
  //yield put(newDealerActionCreators.toggleEventSave(action.payload));

  const event: INewDealerRequestCompleteEvent = yield select((state: IState) =>
    getNewDealerRequestCompleteEvent(state, action.payload)
  );

  if (event) {
    const response: IApiExecuteRespone<IEntityWithMessages<null>> = yield call(
      api.deleteNewDealerRequestCompleteEvent,
      event
    );

    if (!response.requestFailed && response.value) {
      yield processMessages(response.value);

      yield put(newDealerActionCreators.removeCompleteEvent(action.payload));
    } else {
      yield showFailedRequestDialog(response);
    }
  }

  //yield put(newDealerActionCreators.toggleEventSave(action.payload));
}

export function* watchDeleteNewDealerRequestCompleteEvent() {
  yield takeEvery(NewDealerActionKeys.DELETE_NEW_DEALER_COMPLETE_REQUEST_EVENT, deleteNewDealerRequestCompleteEvent);
}
